export default __webpack_public_path__ + "static/media/doctor_dashboard_my_patient.f4a1f97a.svg";